export default __webpack_public_path__ + "static/media/Button-Vault.61dd91a2.svg";